module.exports = __webpack_public_path__ + "img/thumb-011.5d74a37a.png";